export const actionTypes = {
  // get
  GET_TISA_FOREX_RATE_CATEGORY_START: 'GET_TISA_FOREX_RATE_CATEGORY_START',
  GET_TISA_FOREX_RATE_CATEGORY_SUCCESS: 'GET_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  GET_TISA_FOREX_RATE_CATEGORY_FINISH: 'GET_TISA_FOREX_RATE_CATEGORY_FINISH',

  // get all
  GET_ALL_TISA_FOREX_RATE_CATEGORY_START: 'GET_ALL_TISA_FOREX_RATE_CATEGORY_START',
  GET_ALL_TISA_FOREX_RATE_CATEGORY_SUCCESS: 'GET_ALL_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  GET_ALL_TISA_FOREX_RATE_CATEGORY_FINISH: 'GET_ALL_TISA_FOREX_RATE_CATEGORY_FINISH',

  // add
  ADD_TISA_FOREX_RATE_CATEGORY_START: 'ADD_TISA_FOREX_RATE_CATEGORY_START',
  ADD_TISA_FOREX_RATE_CATEGORY_SUCCESS: 'ADD_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  ADD_TISA_FOREX_RATE_CATEGORY_FINISH: 'ADD_TISA_FOREX_RATE_CATEGORY_FINISH',
  ADD_TISA_FOREX_RATE_CATEGORY_RESET: 'ADD_TISA_FOREX_RATE_CATEGORY_RESET',

  // update
  UPDATE_TISA_FOREX_RATE_CATEGORY_START: 'UPDATE_TISA_FOREX_RATE_CATEGORY_START',
  UPDATE_TISA_FOREX_RATE_CATEGORY_SUCCESS: 'UPDATE_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  UPDATE_TISA_FOREX_RATE_CATEGORY_FINISH: 'UPDATE_TISA_FOREX_RATE_CATEGORY_FINISH',
  UPDATE_TISA_FOREX_RATE_CATEGORY_RESET: 'UPDATE_TISA_FOREX_RATE_CATEGORY_RESET',

  // delete
  DELETE_TISA_FOREX_RATE_CATEGORY_START: 'DELETE_TISA_FOREX_RATE_CATEGORY_START',
  DELETE_TISA_FOREX_RATE_CATEGORY_SUCCESS: 'DELETE_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  DELETE_TISA_FOREX_RATE_CATEGORY_FINISH: 'DELETE_TISA_FOREX_RATE_CATEGORY_FINISH',

  // single activate
  SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST:
    'SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST',
  SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS:
    'SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH:
    'SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH',

  // single deactivate
  SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST:
    'SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST',
  SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS:
    'SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH:
    'SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH',
}
